import { ENVIROMENT } from "../util/constants";
const CASEMASTERS_CDN_URL = "https://casemasters.azureedge.net";

export const CASEMASTERS_LOGO_URL = `${CASEMASTERS_CDN_URL}/public/logo-v-zXr4v4onaL.png`;

export let PROFILE_PICTURES_BASE_URL;

if (ENVIROMENT === "PRODUCTION") {
  PROFILE_PICTURES_BASE_URL = "https://casemasters.azureedge.net/profile-pictures";
} else {
  PROFILE_PICTURES_BASE_URL = "https://casemasters-dev.azureedge.net/profile-pictures";
}

export const CASEMASTERS_ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.casemasters.android&hl=en";

export const CASEMASTERS_IOS_APP_URL = "https://itunes.apple.com/us/app/casemasters/id1326535330";

export default {
  CASEMASTERS_LOGO_URL,
  PROFILE_PICTURES_BASE_URL,
};



// WEBPACK FOOTER //
// ./src/constants/urls.js